import type {
  AuthenticationResponseJSON,
  PublicKeyCredentialRequestOptionsJSON,
} from '@simplewebauthn/browser';
import { ceremoniesRunInTheSheet, loadPasskeySheet } from '@/desktop/passkeySheetPlace';
import { effectiveDeploymentAddress } from '@/features/onboarding/deploymentAddress';
import { assertCeremonyRunsHere } from './passkeyOrigin';

/**
 * A passkey assertion where this page can make one: in the page itself at the ceremony's origin, or
 * in the desktop app's passkey sheet. One place for a sign-in (`AuthStore`) and an answer's presence
 * confirmation (F-0499, `features/decisions/signedAnswer.ts`).
 */
export async function passkeyAssertion(
  options: PublicKeyCredentialRequestOptionsJSON,
  origin: string | undefined,
): Promise<AuthenticationResponseJSON> {
  if (!ceremoniesRunInTheSheet()) {
    assertCeremonyRunsHere(origin);
    return (await import('@simplewebauthn/browser')).startAuthentication({ optionsJSON: options });
  }
  return (await loadPasskeySheet()).runCeremonyInPasskeySheet(
    { kind: 'get', options },
    origin ?? effectiveDeploymentAddress(),
  ) as Promise<AuthenticationResponseJSON>;
}
